import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Table } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";

const ListBrokerReport = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    loadDataBroker,
    getDocumentsBroker,
    documentsBroker,
    countBroker,
  } = rootStore.reportStore;

  useEffect(() => {
    getDocumentsBroker();
  }, [getDocumentsBroker]);

  if (!loadDataBroker) return <LoadingComponent content="Cargando" />;
  return (
    <div className="TableScroll">
    <Table striped basic unstackable compact singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Agente Comercial</Table.HeaderCell>
          <Table.HeaderCell>Admin User</Table.HeaderCell>
          <Table.HeaderCell>Nombre Cliente</Table.HeaderCell>
          <Table.HeaderCell>NIT</Table.HeaderCell>
          <Table.HeaderCell>No. Documentos</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {documentsBroker?.length > 0 ? (
          documentsBroker.map((b) => (
            <Table.Row key={`${b.brokerId}-${b.tenantName}`}>
              <Table.Cell singleLine>{b.brokerName}</Table.Cell>
              <Table.Cell singleLine>{b.adminUsername}</Table.Cell>
              <Table.Cell singleLine>{b.tenantName}</Table.Cell>
              <Table.Cell singleLine>{b.companyId}</Table.Cell>
              <Table.Cell>{b.numberOfDocuments}</Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key="brokerReportNull">
            <Table.Cell>No existen Agentes</Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell>Total</Table.HeaderCell>
          <Table.HeaderCell>{countBroker}</Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
    </div>
  );
};

export default observer(ListBrokerReport);
